module.exports = __webpack_public_path__ + "img/tick-nav.80433af4.svg";